/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { forwardRef } from 'react';

import { DeviceModel } from '../../../core/device';
import { MousetrapProps } from './MousetrapProps';

import './Mousetrap.scss';

const Mousetrap = forwardRef<HTMLDivElement, MousetrapProps>(
    ({ children, value, className, style }, ref): JSX.Element => {
        const mousetrapClasses = `${DeviceModel.isWebOsPlatform() ? 'mousetrap' : ''}${
            className ? ` ${className}` : ''
        }`;

        return (
            <React.Fragment>
                <div className={mousetrapClasses} data-value={value} style={style} ref={ref}>
                    {children}
                </div>
            </React.Fragment>
        );
    },
);

export default Mousetrap;
